(function($) {
  // On DOM ready
  $(function() {
    var wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: true, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
      callback: function(box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null // optional scroll container selector, otherwise use window
    });
    wow.init();
  });

  $.fn.imageResponsiveIe = function() {
    return this.each(function() {
      var imgUrl = $(this)
        .find("img")
        .prop("src");
      if (imgUrl) {
        $(this)
          .find("img")
          .attr("style", "display: none !important");
        $(this)
          .css("backgroundImage", "url(" + imgUrl + ")")
          .css({
            "background-repeat": "no-repeat",
            "background-position": "center",
            "background-size": "cover"
          });
      }
    });
  };

  $.fn.imageResponsiveTopIe = function() {
    return this.each(function() {
      var imgUrl = $(this)
        .find("img")
        .prop("src");
      if (imgUrl) {
        $(this)
          .find("img")
          .attr("style", "display: none !important");
        $(this)
          .css("backgroundImage", "url(" + imgUrl + ")")
          .css({
            "background-repeat": "no-repeat",
            "background-position": "top",
            "background-size": "cover"
          });
      }
    });
  };

  $.fn.imageResponsiveRightIe = function() {
    return this.each(function() {
      var imgUrl = $(this)
        .find("img")
        .prop("src");
      if (imgUrl) {
        $(this)
          .find("img")
          .attr("style", "display: none !important");
        $(this)
          .css("backgroundImage", "url(" + imgUrl + ")")
          .css({
            "background-repeat": "no-repeat",
            "background-position": "right",
            "background-size": "cover"
          });
      }
    });
  };

  $(document).ready(function() {
    if (window.matchMedia("(max-width: 991px)").matches) {
      $("#page_footer .footer-top .item ul").css("display", "none");
      $("#page_footer .footer-top .item .widgettitle").click(function(e) {
        e.preventDefault();
        $(this)
          .next(".menu-footer-menu-2-container")
          .find(".item-split ul")
          .css("display", "block");
      });
    } else {
      $("#page_footer .footer-top .item ul").css("display", "block");
    }
  });

  $(window).on("resize", function() {
    if (window.matchMedia("(max-width: 991px)").matches) {
      $("#page_footer .footer-top .item ul").css("display", "none");
      $("#page_footer .footer-top .item .widgettitle").click(function(e) {
        e.preventDefault();
        $(this)
          .next(".menu-footer-menu-2-container")
          .find(".item-split ul")
          .css("display", "block");
      });
    } else {
      $("#page_footer .footer-top .item ul").css("display", "block");
    }
  });

  $(document).ready(function() {
    if ($("section").hasClass("second-hero-banner")) {
      $("body").addClass("landing_v2");
    }
  });
})(jQuery);
